import { createContext, useEffect } from 'react';
import { CustomProvider } from 'base/src/utils/routeUtil';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { StatusRoute } from 'base/src/store/util/action/utilAction';
import { GetCarteiraPermissao } from '../../store/carteiraAdmin/actions/carteiraAdminAction';

// Importando o contexto base do domínio
import DomainCarteiraProvider, { useCarteira as useDomainCarteira } from 'domain/utils/context/carteiraBaseContext';

import { RootStateCarteira } from '../../store/carteiraReducer';
import { CarteiraPermissaoTipo } from 'domain/types/_carteira/carteiraAdmin/carteiraPermissaoTipo';

// Interface estendida que inclui funcionalidades específicas do projeto carteira
interface CarteiraContextType {
  walletBalance: number | null;
  loading: boolean;
  fetchBalance: () => Promise<void>;
}

const CarteiraContext = createContext<CarteiraContextType | undefined>(undefined);

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    carteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
    carteiraPermissao: state.CarteiraAdminReducer.CarteiraPermissao,
  }),
  { StatusRoute, GetCarteiraPermissao }
);

interface WalletProviderProps extends CustomProvider, PropsFromRedux<typeof connector> {
}

// Componente interno que usa o domainCarteira
function CarteiraProviderInner(props: WalletProviderProps) {
  // Agora useDomainCarteira está dentro do DomainCarteiraProvider
  const { walletBalance, loading, fetchBalance } = useDomainCarteira();

  // Lógica específica para permissões de administrador
  useEffect(() => {
    if (props.carteiraPermissao == null) { return }

    if (props.carteiraPermissao.CarteiraPermissaoTipoID == CarteiraPermissaoTipo.Administrador) {
      props.StatusRoute("admin", true);
    } else {
      props.StatusRoute("admin", false);
    }
  }, [props.carteiraPermissao]);
 
  // Busca permissões quando carteiraUsuario muda
  useEffect(() => {
    if (props.carteiraUsuario == null || props.carteiraUsuario.length === 0) { return }

    if (props.carteiraPermissao == null) {
      props.GetCarteiraPermissao(props.carteiraUsuario[0].CarteiraID);
    }
  }, [props.carteiraUsuario]);
 
  return (
    <CarteiraContext.Provider value={{ walletBalance, loading, fetchBalance }}>
      {props.children}
    </CarteiraContext.Provider>
  );
}

function CarteiraProvider(props: WalletProviderProps) {
  return (
    <DomainCarteiraProvider>
      <CarteiraProviderInner {...props} />
    </DomainCarteiraProvider>
  );
}

export default connector(CarteiraProvider);